module.exports = __webpack_public_path__ + "img/motorway_2x2_z18.66a0d4b5.svg";